import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Calendar, { DispatchProps, OwnProps, StateProps } from './CalendarTab';
import { StoreState } from 'src/store/reducers';
import { getCasesSmall, updateCase } from 'src/store/actions/case-actions';
import { getSeances } from 'src/store/actions/seance-actions';
import { getCases } from 'src/store/actions/case-actions';
import { getProvidersSmall } from 'src/store/actions/provider-actions';
import { QueryParams } from 'src/types/grid';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.cases.inProgress,
        inProgressSeances: state.seances.inProgress,
        caseEnt: state.cases.current,
        seances: state.seances.data,
        providers: state.providers.data,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getSeances(params)),
        getCases: (params: QueryParams) => dispatch(getCasesSmall(params)),
        getProviders: (params: QueryParams) =>
            dispatch(
                getProvidersSmall({
                    filters: {
                        showAll: 1,
                    },
                    page: 1,
                    itemsPerPage: 1200,
                }),
            ),
        updateCaseAction: (data) =>
            dispatch(
                updateCase(
                    data,
                    () => false,
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
    };
}

const CalendarTab = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(Calendar);

export default CalendarTab;
